import * as tslib_1 from "tslib";
import React from 'react';
import PropTypes from 'prop-types';
import LinkViewer from './LinkViewer';
var Strategy = function (contentBlock, callback, contentState) {
    contentBlock.findEntityRanges(function (character) {
        var entityKey = character.getEntity();
        return (entityKey !== null &&
            contentState.getEntity(entityKey).getType() === 'LINK');
    }, callback);
};
var Link = /** @class */ (function (_super) {
    tslib_1.__extends(Link, _super);
    function Link() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Link.prototype.render = function () {
        var _a = this.props, entityKey = _a.entityKey, contentState = _a.contentState, className = _a.className, children = _a.children, anchorTarget = _a.anchorTarget, relValue = _a.relValue;
        var componentData = contentState.getEntity(entityKey).getData();
        return (React.createElement(LinkViewer, { componentData: componentData, className: className, anchorTarget: anchorTarget, relValue: relValue }, children));
    };
    Link.propTypes = {
        entityKey: PropTypes.string.isRequired,
        contentState: PropTypes.object.isRequired,
        children: PropTypes.arrayOf(PropTypes.element).isRequired,
        className: PropTypes.string,
        anchorTarget: PropTypes.string,
        relValue: PropTypes.string,
    };
    return Link;
}(React.Component));
export { Strategy, Link };
//# sourceMappingURL=LinkDecorator.js.map